import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  HomeIcon,
  CalendarIcon,
  ClipboardDocumentListIcon,
  ShieldCheckIcon,
  Bars3Icon,
} from '@heroicons/react/24/outline';

interface BottomNavProps {
  onOpenSidebar: () => void;
}

const bottomNavItems = [
  { name: 'Home', href: '/', icon: HomeIcon },
  { name: 'Calendar', href: '/calendar', icon: CalendarIcon },
  { name: 'Tasks', href: '/tasks', icon: ClipboardDocumentListIcon },
  { name: 'Security', href: '/security', icon: ShieldCheckIcon },
];

const BottomNav: React.FC<BottomNavProps> = ({ onOpenSidebar }) => {
  const location = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-30 border-t border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800 md:hidden"
         style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}>
      <div className="flex h-16 items-center justify-around">
        {bottomNavItems.map((item) => {
          const isActive = location.pathname === item.href ||
            (item.href !== '/' && location.pathname.startsWith(item.href));
          return (
            <Link
              key={item.name}
              to={item.href}
              className={`flex min-h-[44px] min-w-[44px] flex-col items-center justify-center gap-1 px-3 ${
                isActive
                  ? 'text-primary-600 dark:text-primary-400'
                  : 'text-gray-500 dark:text-gray-400'
              }`}
            >
              <item.icon className="h-6 w-6" />
              <span className="text-[10px] font-medium">{item.name}</span>
            </Link>
          );
        })}
        <button
          onClick={onOpenSidebar}
          className="flex min-h-[44px] min-w-[44px] flex-col items-center justify-center gap-1 px-3 text-gray-500 dark:text-gray-400"
        >
          <Bars3Icon className="h-6 w-6" />
          <span className="text-[10px] font-medium">More</span>
        </button>
      </div>
    </nav>
  );
};

export default BottomNav;
